import { PropsWithChildren } from "react";
import { Navigate, useLocation } from "react-router";

import useAuth from "../../hooks/useAuth";

type Props = {
    requireLoggedOut?: boolean;
};

export default function RequireAuth({ children, requireLoggedOut = false }: PropsWithChildren<Props>) {
    const { isLoggedIn, state } = useAuth();
    const location = useLocation();

    if (state === "initializing") return undefined;

    if (requireLoggedOut && isLoggedIn) {
        const from = location.state?.from?.pathname || "/";
        return <Navigate to={from} replace />;
    }
    if (!requireLoggedOut && !isLoggedIn) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return children;
}
